import { Grid } from '@mantine/core';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoaderSpinner from '../LazyLoaderSpinner';

const CatalogTriggerStats = ({ stats, catalogTrigger }) => {
  if (!stats) {
    return (
      <Grid.Col span={12}>
        <LazyLoaderSpinner />
      </Grid.Col>
    );
  }

  return (
    <>
      <Grid.Col span={12} ta="center">
        <HeaderStatistic title="Events dispatched" stats={stats} stat="events" id={catalogTrigger.id} statKey="count" />
      </Grid.Col>
    </>
  );
};

export default CatalogTriggerStats;
